import { useFeatureFlags } from '@signifyd/legacy-components'
import {
  caseReviewFeatureFlagConfig,
  HAS_NEW_CONFIRMATION_DESTINATION_FIELDS_IN_ADMIN_KEY,
  HAS_RECOMMENDATION_MR_KEY,
} from './CaseReviewFeatureFlagController'

interface CaseReviewFeatureFlags {
  isNewConfirmationDestinationFieldsEnabled: boolean
  isRecommendationMrEnabled: boolean
}

const useCaseReviewFeatureFlags = (): CaseReviewFeatureFlags => {
  const {
    [HAS_NEW_CONFIRMATION_DESTINATION_FIELDS_IN_ADMIN_KEY]: {
      isEnabledForEnvironment: isNewConfirmationDestinationFieldsEnabled,
    },
    [HAS_RECOMMENDATION_MR_KEY]: {
      isEnabledForEnvironment: isRecommendationMrEnabled,
    },
  } = useFeatureFlags(caseReviewFeatureFlagConfig.map(({ key }) => key))

  return {
    isNewConfirmationDestinationFieldsEnabled,
    isRecommendationMrEnabled,
  }
}

export default useCaseReviewFeatureFlags
